import { useMemo } from 'react'

import { useLookupUuidsQuery } from 'features/meetings'
import { recapFilters } from 'features/recaps/constants'

import { buildFilters } from '../utils'


const useFilterParamsWithUuids = (filterParams) => {
  const { data: uuids } = useLookupUuidsQuery({ filters: filterParams })

  if (!uuids) {
    return null
  }

  return {
    ...filterParams,
    ...uuids,
  }
}

export const createUseResultsCount = (useGetMeetingsQuery, recapScope) => (filterParams, skip) => {
  const filtersToUse = useFilterParamsWithUuids(filterParams)

  const filters = useMemo(
    () => (skip ? null : buildFilters(filtersToUse)),
    [skip, filtersToUse]
  )

  const {
    data: searchData = undefined,
    isFetching: searchFetching = false
  } = useGetMeetingsQuery?.(
    {
      ...recapFilters,
      ...filters,
      ...(recapScope ? { recapScope } : {}),
      statusIds: []
    },
    { skip }
  ) ?? {}

  if (skip) {
    return {
      count: 0,
      isLoading: false
    }
  }

  return {
    count: searchData?.meetings?.total || 0,
    isLoading: searchFetching
  }
}
